module.exports = __webpack_public_path__ + "static/img/1_3_1.ad98d513.jpg";